

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const PaymentAuthorizationSection = () => {
  return (
    <div>
      <Paragraph>
        Customer authorizes Club Sports Solutions L.L.C. ("Provider") and its
        payment processing partners to automatically charge Customer's designated
        payment method for all subscription fees and other amounts due under this
        Agreement.
      </Paragraph>

      <Paragraph>
        <Text strong>Recurring Billing Authorization</Text>
      </Paragraph>

      <ul>
        <li>Monthly subscription fees will be charged automatically.</li>
        <li>Charges will be processed using the payment method on file.</li>
        <li>Customer is responsible for maintaining accurate billing information.</li>
      </ul>

      <Alert
        message="Valid Payment Method Required"
        description="Customer must maintain a valid payment method at all times while using TrackBiz. Failure to maintain a valid payment method may result in service interruption or account suspension."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        If a payment is declined, rejected, reversed, disputed, or otherwise
        unsuccessful, Provider may attempt to reprocess the payment using the
        payment method on file.
      </Paragraph>

      <Paragraph>
        Customer authorizes Provider to send payment receipts, billing notices,
        renewal notifications, and account-related communications electronically
        using the email address provided during onboarding.
      </Paragraph>

      <Paragraph>
        If any amount remains unpaid for more than fifteen (15) days after its due
        date, Provider may suspend access to TrackBiz until all outstanding amounts
        have been paid in full.
      </Paragraph>

      <Alert
        message="Service Suspension"
        description="Provider reserves the right to suspend access to TrackBiz for non-payment. Subscription fees will continue to accrue during any suspension period unless the subscription is formally terminated."
        type="error"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer remains responsible for all charges incurred prior to any account
        cancellation, suspension, or termination.
      </Paragraph>
    </div>
  );
};

export default PaymentAuthorizationSection;